module.exports = __webpack_public_path__ + "static/media/VN.2a1df764.svg";